module.exports = __webpack_public_path__ + "static/img/manual_zh_28.15aa47e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_28.png
// module id = lCsC
// module chunks = 4